import React from "react";
import RootElement from "./src/context/app.context";
import "@fontsource-variable/open-sans"; 
import "@fontsource-variable/montserrat";

export const wrapRootElement = ({ element }) => {
    return <RootElement>{element}</RootElement>;
}